// tslint:disable
import { BaseAvroRecord } from "../../BaseAvroRecord";
import { NavigationType } from "./NavigationTypeEnum";

export interface Browser {
    userAgent: string;
    language: string;
    platform: string;
    name?: null | string;
}

export interface Tab {
    isNewTab: boolean;
    tabCount: number;
    tabId: string;
}

export interface Navigation {
    referrerUrl: string;
    navigationType?: null | NavigationType;
}

export interface DeviceInterface {
    browser?: null | Browser;
    tab?: null | Tab;
    navigation: Navigation;
}

export class Device extends BaseAvroRecord implements DeviceInterface {

    public browser?: null | Browser = null;
    public tab?: null | Tab = null;
    public navigation!: Navigation;

    public static readonly subject: string = "device";
    public static readonly schema: object = {
    "type": "record",
    "name": "Device",
    "namespace": "storyblocks.common",
    "fields": [
        {
            "name": "browser",
            "type": [
                "null",
                {
                    "type": "record",
                    "name": "Browser",
                    "namespace": "storyblocks.common.frontend",
                    "fields": [
                        {
                            "name": "userAgent",
                            "type": "string"
                        },
                        {
                            "name": "language",
                            "type": "string"
                        },
                        {
                            "name": "platform",
                            "type": "string"
                        },
                        {
                            "name": "name",
                            "type": [
                                "null",
                                "string"
                            ],
                            "default": null
                        }
                    ]
                }
            ],
            "default": null
        },
        {
            "name": "tab",
            "type": [
                "null",
                {
                    "type": "record",
                    "name": "Tab",
                    "namespace": "storyblocks.common.frontend",
                    "fields": [
                        {
                            "name": "isNewTab",
                            "type": "boolean"
                        },
                        {
                            "name": "tabCount",
                            "type": "int"
                        },
                        {
                            "name": "tabId",
                            "type": "string"
                        }
                    ]
                }
            ],
            "default": null
        },
        {
            "name": "navigation",
            "type": {
                "type": "record",
                "name": "Navigation",
                "namespace": "storyblocks.common.frontend",
                "fields": [
                    {
                        "name": "referrerUrl",
                        "type": "string"
                    },
                    {
                        "name": "navigationType",
                        "type": [
                            "null",
                            {
                                "type": "enum",
                                "name": "NavigationType",
                                "namespace": "storyblocks.common.enums",
                                "symbols": [
                                    "TYPE_NAVIGATE",
                                    "TYPE_RELOAD",
                                    "TYPE_BACK_FORWARD",
                                    "TYPE_RESERVED",
                                    "OUTDATED_SCHEMA"
                                ],
                                "default": "OUTDATED_SCHEMA"
                            }
                        ],
                        "default": null
                    }
                ]
            }
        }
    ]
}

    public schema(): object {
        return Device.schema;
    }

    public subject(): string {
        return Device.subject;
    }
}
